export default __webpack_public_path__ + "static/media/oa-logo.781fb75c.png";